import axios from '../../utils/axios'


// A mock function to mimic making an async request for data
export function getSinglePost(id) {
    return axios.get(`/blogs/${id}`)
  }
